module.exports = require('./thumbor')(require('./modules/create-hmac-sha'));